export default {
      id: "icon-arrow-left-usage",
      viewBox: "0 0 15.03 30.03",
      url: __webpack_public_path__ + "icons.svg#icon-arrow-left",
      toString: function () {
        return this.url;
      }
    }